import { useTranslation } from 'react-i18next'
import { Select, SelectContent, SelectItem, SelectTrigger } from '@/components/ui/select'

export type PaysNumero = 'CA' | 'US'

/**
 * Le pays d'un numéro, avec de vrais drapeaux en image : les drapeaux emoji
 * (🇨🇦) ne s'affichent pas sur Windows, qui écrit « CA » à la place.
 */
export function Drapeau({ pays }: { pays: PaysNumero }) {
  return (
    <img
      src={`https://flagcdn.com/w40/${pays.toLowerCase()}.png`}
      alt=""
      className="w-5 h-auto rounded-[2px] flex-shrink-0"
    />
  )
}

export function SelecteurPays({
  value,
  onChange,
  className = '',
  sombre = false,
}: {
  value: PaysNumero
  onChange: (p: PaysNumero) => void
  className?: string
  /** Sur fond bleu nuit (onboarding). */
  sombre?: boolean
}) {
  const { t } = useTranslation()
  const nom = (p: PaysNumero) => t(`pays.${p}`)
  return (
    <Select value={value} onValueChange={(v) => onChange(v as PaysNumero)}>
      {/* Bordure nette et chevron plein : on doit voir au premier coup d'œil que le pays se change. */}
      <SelectTrigger
        className={`cursor-pointer [&>svg]:!opacity-100 ${
          sombre
            ? 'border-white/[0.14] bg-white/[0.04] text-white hover:border-white/30 hover:bg-white/[0.07] dark:bg-white/[0.04] [&>svg]:!text-white/80'
            : 'border-slate-300 hover:border-slate-400 hover:bg-slate-50 [&>svg]:!text-slate-700'
        } ${className}`}
        aria-label={t('pays.label')}
      >
        <span className="flex items-center gap-2">
          <Drapeau pays={value} />
          {nom(value)}
        </span>
      </SelectTrigger>
      <SelectContent className={sombre ? 'bg-[#12223D] border-white/10 text-white' : undefined}>
        {(['CA', 'US'] as const).map((p) => (
          <SelectItem key={p} value={p} className={sombre ? 'focus:bg-white/10 focus:text-white' : undefined}>
            <span className="flex items-center gap-2">
              <Drapeau pays={p} />
              {nom(p)}
            </span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
